import {createReducer, createTypes} from 'reduxsauce'
import celulaActions from './celulaRedux'
import igrejaActions from './igrejaRedux'
import api from '../Services/api'
import {merge} from 'ramda'
import gileadeGlobalConfig from '../gileadeGlobalConfig'
import {getExternalParams} from '../Services/externalParams'

const getUrlToken = () => {
  return getExternalParams().gileadeToken
}

export default {
  startup: () => async (dispatch) => {
    const privateToken = getUrlToken()
    let isAuthenticated = false
    if (privateToken) {
      const {data, ok} = await api.verify(privateToken)
      isAuthenticated = ok && !!data.idUser
    } 
    const payload = { isAuthenticated }
    api.setToken(isAuthenticated ? privateToken : gileadeGlobalConfig.clientId) 
    dispatch({type: 'STARTUP', payload})
    dispatch(celulaActions.fetchCelulas())
  }
}

const initialState = {
  loading: true
}

export const reducer = createReducer(initialState, {
  STARTUP: (state, {payload}) => merge(state, {
    ...payload,
    loading: false
  })
})

export const isAuthenticated = state => state.app.isAuthenticated



// WEBPACK FOOTER //
// ./src/Redux/appRedux.js